export const triggerAnalyticsEvent = (
  eventName = "msc_event",
  eventData = {}
) => {
  const event = new CustomEvent(eventName, {
    detail: eventData
  });
  document.dispatchEvent(event);
};

export const handleLetterClick = (data, callback = () => {}) => {
  triggerAnalyticsEvent("feed_card_click", data);

  callback();
};

export const handleCardView = (data) => {
  triggerAnalyticsEvent("feed_card_view", data);
};
